import { useAuthStore } from '@/stores/auth.store.js'
import Cookie from 'js-cookie'

export default function auth({ to, next }) {
  const authStore = useAuthStore()
  const authToken = Cookie.get('_pup_access_token')
  const authUser = Cookie.get('_pup_user')

  if (!authToken) {
    // set redirect path
    sessionStorage.setItem('redirectPath', to.path)
    localStorage.removeItem('_pup_new_user')
    // clear user and token from localstorage and store
    authStore.logout()
    return next({ name: 'Login' })
  } else {
    localStorage.removeItem('_pup_new_user')
    return next()
  }
}
